import AOS from 'aos';
import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { AgGridReact } from 'ag-grid-react';
import Select from 'react-select';
import axios from 'axios';
import moment from 'moment';
import { Link } from "react-router-dom";
import ImportedURL from "../../common/api";
import { Currency } from "../../common/validate";
import { Spinner } from "react-bootstrap";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import { AiOutlineAppstore, AiOutlineQuestionCircle, GrFormAdd } from "react-icons/ai";
import { Error, Success } from '../../common/swal';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'
import { AC_EMPTY_EDUCATION, AC_HANDLE_INPUT_CHANGE_EDUCATION, AC_LIST_EDUCATION, AC_VIEW_EDUCATION } from '../../actions/educationAction';

class ListEducation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalType: "Add",
            columnDefs: [
                { headerName: '#', valueGetter: "node.rowIndex+1", width: 50, hide: true, sortable: false, filter: false, cellStyle: { 'text-align': 'center' } },

                { headerName: 'Name', field: 'name', width: 200, cellStyle: { 'text-align': 'left' }, floatingFilter: true },
                {
                    headerName: 'Status', width: 150, field: 'status', cellStyle: { 'text-align': 'center' }, headerClass: 'ag-center-header', suppressMenu: true,
                    cellRenderer: function (params) {
                        if (params.data.status) {
                            return `<span type="button" class="tag tag-green active_status" data-action-type="Status">Active</span>`;
                        } else if (!params.data.status) {
                            return '<span type="button" class="tag tag-danger inactive_status" data-action-type="Status">Inactive</span>';
                        }
                    }
                },
                {
                    headerName: 'Action', width: 150, field: 'actions', cellStyle: { 'text-align': 'center' }, headerClass: 'ag-center-header', suppressMenu: true, sortable: false, filter: false,
                    cellRenderer: function (params) {
                        return params.value;
                    }
                },
            ],
            defaultColumDef: {
                editable: false,
                sortable: true,
                resizable: true,
                filter: true,
                flex: 1,
                minWidth: 100,
            },
            id: '',
            nameError: false,
        }
    }
    componentDidMount() {
        this.props.ListEducation()
    }
    changeModal = (e) => {
        this.setState({ modalType: e.target.id, roomnameError: false, editSpi: false, });
        this.props.EmptyEducation();
    }
    onRowClicked = event => {
        const { AccountState } = this.props;
        const rowValue = event.event.target;
        const value = rowValue.getAttribute('data-action-type');
        // if (value === 'View') {
        //     this.props.ResetRoomArea();
        //     this.setState({ modalType: "View", ccError: false, nameError: false, phonenumberError: false });
        //     this.props.ViewEducation(event.data);
        // }
        if (value === 'Edit') {
            this.setState({ modalType: "Edit", id: event.data._id, nameError: false, editSpi: true });
            this.props.ViewEducation(event.data._id);
        }

        if (value === 'Delete') {
            Swal.fire({
                title: 'Are you sure want to delete?',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
                imageUrl: '../../assets/images/delete.png',
                customClass: {
                    popup: 'swal_pop',
                    title: 'swal_title',
                    image: 'swal_image',
                    actions: 'swal_action',
                    confirmButton: 'swal_confirm',
                    cancelButton: 'swal_close',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.get(ImportedURL.API.softDeleteRoomArea + '/' + event.data._id)
                        .then((res) => {
                            Success('Education deleted successfully');
                            this.props.ListEducation();
                        }).catch(({ response }) => {
                            Error(response)
                        });
                    // this.props.DeleteCategory(event.data._id)
                }
            })
        }
        if (value === 'Status') {
            Swal.fire({
                title: 'Are you sure you want to change the status?',
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: 'Ok',
                imageUrl: 'assets/images/status.png',
                customClass: {
                    popup: 'swal_pop',
                    title: 'swal_title',
                    image: 'swal_image',
                    actions: 'swal_action',
                    confirmButton: 'swal_confirm',
                    cancelButton: 'swal_close',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post(ImportedURL.API.statusChange, { id: event.data._id, status: !event.data.status, model: 'educations' })
                        .then((data) => {
                            Success('Status updated successfully')
                            this.props.ListEducation();
                        }).catch(({ response }) => {
                            if (response.status == 500) {
                                Error(' Internal Server Error')
                            } else if (response.status == 502) {
                                Error(' Bad Gateway')
                            } else {
                                Error(response.statusMessage)
                            }
                        });
                }
            })
        }
    }
    onGridReady = (params) => {
        this.gridColumnApi = params.columnApi;
        this.gridApi = params.api;
        this.gridApi.sizeColumnsToFit();
    }
    exportToCSV = () => {
        this.gridApi.exportDataAsCsv({
            columnKeys: ['#', 'name'],
            fileName: "educationlist.csv",
            processCellCallback: function (params) {
                return params.value;
            }
        })
    }
    exportPDF = () => {
        const { educationState } = this.props;
        const exportData = educationState.listEducation;
        const unit = "pt";
        const size = "A4";
        const orientation = "landscape";
        const marginLeft = 15;
        var img = new Image();
        img.src = '../assets/images/logo-1.png';
        const doc = new jsPDF(orientation, unit, size);
        doc.setFontSize(15);
        const title = "Education List";
        var headers = [['#', 'Name']];
        var data = exportData.map((elt, i) => {
            return [
                i + 1,
                (elt.name) ? elt.name : "---",
            ]
        });
        let content = {
            startY: 70,
            head: headers,
            headStyles: { fillColor: [215, 234, 255], textColor: [28, 48, 120], },
            body: data,
            styles: {
                rowHeight: 30,
                valign: 'middle',
                lineWidth: 0.5,
            },
            margin: {
                left: 10,
                right: 10
            },
            autoPaging: "text",
        };
        doc.addImage(img, 'png', 780, 6, 50, 50);
        doc.setTextColor(28, 48, 120);
        doc.text(title, marginLeft, 40);
        doc.setTextColor(28, 48, 120)
        autoTable(doc, content);
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(11);
            doc.setTextColor(110);
            doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
            doc.setFontSize(11);
            doc.text('This is an auto-generated report from ACWcard (www.acwcard.com)', 20, 575)
        }
        doc.save("educationlist.pdf")
    }
    onChange = e => {
        const { name, value } = e.target;
        if (name == 'name') {
            if (value) {
                this.props.HandleChange(name, value)
                this.setState({ nameError: false })
            } else {
                this.props.HandleChange(name, value)
                this.setState({ nameError: true })
            }
        }
    }
    submit = (e) => {
        const getData = this.props.educationState.education;
        const data = { ...getData };
        for (let key in data) {
            if (data.hasOwnProperty(key) && typeof data[key] === 'string') {
                data[key] = data[key].trim();
            }
        }
        let valid = 1;
        if (!data.name) {
            this.setState({ nameError: true })
            this.props.HandleChange("name", '');
            valid = 0;
        }
        if (valid) {
            this.setState({ saving: true })
            if (this.state.modalType === "Add") {
                axios.post(ImportedURL.API.addEducation, data)
                    .then((res) => {
                        this.setState({ saving: false })
                        this.props.EmptyEducation();
                        Success("Education created successfully");
                        this.props.ListEducation();
                        let btn = document.getElementById("closeModal");
                        btn.click();
                    }).catch(({ response }) => {
                        console.log(response);
                        this.setState({ saving: false })
                    });
            } else {
                axios.post(ImportedURL.API.updateEducation + '/' + this.state.id, data)
                    .then((res) => {
                        this.setState({ saving: false })
                        Success("Education updated successfully");
                        this.props.EmptyEducation();
                        this.props.ListEducation();
                        let btn = document.getElementById("closeModal");
                        btn.click();
                    }).catch(({ response }) => {
                        this.setState({ saving: false })
                        console.log(response);
                    });
            }
        }
    }

    render() {
        const { accountState, educationState } = this.props;
        const account = accountState.account;
        const rowData = educationState.listEducation;
        const data = educationState.education;
        const spinner = educationState.spinner;
        const previleges = accountState.previleges;
        const Previlege = previleges.find(obj => { return obj.name == "Bloodgroup" });
        const editOption = (Previlege && Previlege.edit) ? '<button type="button" class="btn btn-icon" data-action-type="Edit"  data-toggle="modal" data-target="#exampleModal"><i class="fa fa-edit" data-action-type="Edit"></i></button>' : ''

        if (rowData.length > 0) {
            rowData.forEach(object => {
                object.actions = editOption;
            });
        }
        const limitOptions = [
            { value: '25', label: '25' },
            { value: '50', label: '50' },
            { value: '100', label: '100' }
        ]

        return (
            <>
                <div class="content-header">
                    <div class="container-fluid">
                        <div class="row mb-2">
                            <div class="col-12 breadcome_value">
                                <ol class="breadcrumb ">
                                    <li class="breadcrumb-item header_color_breadcome"> <Link to='/admin'>Dasboard</Link></li>
                                    <li class="breadcrumb-item active">List Education</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="col-md-12">
                        <div class="card card-primary header_border" >
                            <div class="table-title">
                                <div className="card-header">
                                    <h3 className="card-title d-flex "> <div className='rounded_icon'><i className="fa fa-book"></i></div><h2 class="card-title header_title">LIST Education</h2> </h3>
                                    <div className="card-options">
                                        <div className="d-flex justify-content-end">
                                            <div className="header-action mr-2">
                                                {(Previlege && Previlege.add) ? <button type="button" className="btn btn-primary button_color" id='Add' data-toggle="modal" data-target="#exampleModal" onClick={(e) => this.changeModal(e)}> <i className="fa fa-plus mr-2" id='Add' />Add</button> : ""}
                                            </div>
                                            <div>
                                                {(rowData.length > 0) ? <>
                                                    <a className="btn btn-primary btn-sm nav-link dropdown-toggle button_export" data-bs-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-download mr-2" aria-hidden="true"></i>Export</a>
                                                    <div className="dropdown-menu">
                                                        <a className="dropdown-item" type='button' onClick={this.exportToCSV}><i className="dropdown-icon fa fa-file-excel-o"></i> Excel</a>
                                                        <a className="dropdown-item" type='button' onClick={this.exportPDF}><i className="dropdown-icon fa fa-file-pdf-o"></i> PDF</a>
                                                    </div>
                                                </> : []}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-3">
                                            <label for="exampleInputEmail1">Limit</label>
                                            <div className="form-group">
                                                <Select
                                                    onChange={(e) => this.gridApi.paginationSetPageSize(Number(e.value))}
                                                    options={limitOptions}
                                                    defaultValue={limitOptions[0]}
                                                    className='limit_size overall_select_option'
                                                    styles={{
                                                        menu: provided => ({ ...provided, zIndex: 9999, textAlign: 'left' })
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        <div className="ag-theme-alpine">
                                            <AgGridReact
                                                rowHeight={75}
                                                paginationPageSize={25}
                                                pagination={true}
                                                onRowClicked={this.onRowClicked}
                                                domLayout={"autoHeight"}
                                                defaultColDef={this.state.defaultColumDef}
                                                rowData={rowData}
                                                rowDragManaged={true}
                                                animateRows={true}
                                                columnDefs={this.state.columnDefs}
                                                onGridReady={this.onGridReady}
                                                overlayNoRowsTemplate={"No rows to display"}
                                            >
                                            </AgGridReact>
                                        </div>
                                        {spinner ?
                                            <div className='common_loader_ag_grid'>
                                                <img className='loader_img_style_common_ag_grid' src='../assets/images/logo.jpg' />
                                                <Spinner className='spinner_load_common_ag_grid' animation="border" variant="info" >
                                                </Spinner>
                                            </div>
                                            : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Modal */}
                    <div className="modal fade" id="exampleModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <div className='rounded_icon'><i className="fa fa-book mr-2"></i></div>
                                    <h5 className="modal-title" id="exampleModalLabel" style={{ marginTop: '5px' }}>Education</h5>
                                    <button type="button" id="closeModal" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true" style={{ fontSize: "23px" }} id="closeModal" onClick={this.clear}>
                                            <img src='../../assets/images/cancel.png' />
                                        </span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Name<span className="ml-1" style={{ color: 'red' }}>*</span></label>
                                                <input type="text" className="form-control" disabled={this.state.modalType == "View"} name='name' value={data.name} onChange={this.onChange} placeholder="Name" />
                                                <div className="invalid-feedback" style={{ display: this.state.nameError ? "block" : 'none' }}> Name is required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.modalType == "Edit" ?
                                    <div className="card-footer text-right mandatory">
                                        <label className="form-label text-left mandatory-label"><span className="mr-1" style={{ color: 'red' }}>*</span>Mandatory Fields </label>
                                        <div className="" >
                                            {
                                                this.state.saving ?
                                                    <button type="button" className="btn commor_save" ><i className="fa fa-spinner fa-spin mr-2"></i>Updating</button>
                                                    :
                                                    <button type="button" className="btn commor_save" onClick={this.submit}><i className="fe fe-save mr-2"></i>Update</button>
                                            }
                                            <button type="button" className="btn btn-secondary" style={{ marginRight: '10px' }} data-dismiss="modal"><i className="fa fa-times mr-2"></i>Close</button>
                                        </div>
                                    </div>
                                    : <div className="card-footer text-right mandatory">
                                        <label className="form-label text-left mandatory-label"><span className="mr-1" style={{ color: 'red' }}>*</span>Mandatory Fields </label>
                                        <div >
                                            {
                                                this.state.saving ?
                                                    <button type="button" className="btn commor_save" ><i className="fa fa-spinner fa-spin mr-2"></i>Saving</button>
                                                    :
                                                    <button type="button" className="btn commor_save" onClick={this.submit}><i className="fe fe-save mr-2"></i>Save</button>
                                            }
                                            <button type="button" className="btn btn-secondary" style={{ marginRight: '10px' }} data-dismiss="modal"><i className="fa fa-times mr-2"></i>Close</button>
                                        </div>
                                    </div>}
                                {/* <div id='overlay' style={{ display: this.state.editSpi && Object.keys(data.roomname).length <= 0 ? 'block' : 'none' }}></div>
                                {this.state.editSpi && Object.keys(data.roomname).length <= 0 ?
                                    <div className='model_loader_poss'>
                                        <img className='loader_img_style_model' src='../../assets/images/load.png' />
                                        <Spinner className='spinner_load_model' animation="border" variant="info" >
                                        </Spinner>
                                    </div>
                                    : ''} */}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        accountState: state.account,
        educationState: state.education,
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        ListEducation: AC_LIST_EDUCATION,
        HandleChange: AC_HANDLE_INPUT_CHANGE_EDUCATION,
        ViewEducation: AC_VIEW_EDUCATION,
        EmptyEducation: AC_EMPTY_EDUCATION
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ListEducation);